import React from "react";
import cityBanner from "../assets/cityBanner.jpg";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";
import "../css/home.css";
import ngclogo from "../assets/ngclogo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

const data = [
  {
    count: 30,
    name: "YEARS OF EXPERIENCE",
    text: "To foster a work environment of mutual respect, innovation, continuous improvement and dedication to customer and employees",
  },
  { count: 400, name: "EXPERIENCED EMLOYEES", text: "" },
  { count: 50, name: "DIFFERENT PRODUCTS AND SERVICES", text: "" },
];

const Banner = () => {
  const bannerStyles = {
    objectFit: "cover",
    width: "100%",
    height: "55vh",
    backgrounAttachment: "fixed",
  };
  return (
    <div>
      <Container fluid className="px-0" id="banner">
        <div id="hero">
          <h4 className="display-5">NGC Enterprise</h4>
          <p className="lead">
            Deliver superior service toward maximum productivity, profitability
            and satisfaction to our clients and their customers.
          </p>
        </div>
        <img src={cityBanner} style={bannerStyles} />
      </Container>

      <Container className="mt-5" id="bannerContainer">
        <Row className="rowCardContainer my-auto gy-3">
          {data.map((val) => {
            return (
              <Col md={4}>
                <Card
                  className="shadow border-0 "
                  style={{ height: "120px", cursor: "pointer" }}
                >
                  <Card.Body className="rowCardContainer my-auto">
                    <Row>
                      <Col md={5}>
                        <h1
                          id="test"
                          className="display-5 fw-bold "
                          style={{ color: "#0A7407" }}
                        >
                          {val.count}+
                        </h1>
                      </Col>
                      <Col md={7} className="px-3">
                        <Stack gap={3}>
                          <div
                            className=" fw-bold px-0 mx-0 text-start"
                            style={{ fontSize: "18px" }}
                          >
                            {val.name}
                          </div>
                          {/* <div className="  text-truncate py-0 my-0 overflow-hidden">
                            {val.text}
                          </div> */}
                        </Stack>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>

      {/* <Container
        style={{
          height: "300px",
          //   backgroundColor: "#395144",
          marginTop: "5rem",
          marginBottom: "2rem",
        }}
      >
        <div className="mt-5"></div>
        <h3 className="py-5 text-light">Service Offered</h3>
        <Row>
          <Col md={2} className="text-dark" id="services">
            <img src={ngclogo} width="140px" alt="NGC Express Logo" />
          </Col>
        </Row>
      </Container> */}
    </div>
  );
};

export default Banner;
